module.exports = __webpack_public_path__ + "static/fonts/DejaVuSansMono-Oblique.a6927e4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSansMono-Oblique.ttf?v=1.1
// module id = 1643
// module chunks = 28